import { Box, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  BGColor02,
  blackColor,
  blackShade19,
  blackShade21,
  blueColor04,
  border25,
  greyColor49,
  lightRedColor02,
  logoImgborder1,
  mobilePrimary,
  outOfStockColor,
  whiteColor,
} from "../configs/styles/muiThemes";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  getActiveBusinessInfo,
} from "../reducers/businessPreview/businessPreviewSlice";
import { getStatsCountInfoData } from "../reducers/businessDashboard/BusinessDashboardSlice";
import DashboardLayout from "../components/Layouts/DashboardLayout";
import { clearBulkProductInfo } from "../reducers/catalogBulkUploadCopy/catalogBulkUploadSlice";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import {
  getCommerceDashboardInfoAPI,
  getMainProductsWithVariantsAPI,
} from "../service/api_calls/BusinessPreview/BusinessPreviewAPI";
import InventoryBulkUpdateContent from "./InventoryBulkUpdate/InventoryBulkUpdateContent";
import { toTitleCase } from "../utils/validationUtils";

function InventoryBulkUpdate() {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [commerceInfo, setCommerceInfo] = useState(null);

  const { activeBusinessInfo, activeBusinessInfoLoader } = useSelector(
    (state) => state.businessPreview
  );

  const { statsCountInfo } = useSelector((state) => state.businessDashboard);

  const [mainProducts, setMainProducts] = useState([]);

  // Get CommerceInfo
  const getCommerceInfoDetails = async (businessId) => {
    const businessCommerceInfo = await getCommerceDashboardInfoAPI(businessId);
    setCommerceInfo(businessCommerceInfo || null);
  };

  // Get All Products With Variants
  const getAllMainProductsWithVariants = async (
    ondcCode,
    ondcSubCode,
    search
  ) => {
    const businessId = sessionStorage.getItem("selectedBusinessId");

    const response = await getMainProductsWithVariantsAPI(
      businessId,
      ondcCode,
      ondcSubCode,
      search
    );
    console.log("getAllMainProductsWithVariants", response);

    setMainProducts(response?.details || []);
  };

  useEffect(() => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    if (businessId) {
      getCommerceInfoDetails(businessId);

      if (!activeBusinessInfo) {
        dispatch(getActiveBusinessInfo(businessId));
      }

      if (mainProducts?.length == 0) {
        getAllMainProductsWithVariants();
        // dispatch(getMainProducts(businessId));
      }

      // Getting Product and Sales Count
      if (!statsCountInfo) {
        dispatch(getStatsCountInfoData(businessId));
      }
    }
    return () => {
      dispatch(clearBulkProductInfo());
    };
  }, []);

  return (
    <Box backgroundColor={BGColor02}>
      <DashboardLayout
        activeSubMenu="inventoryBulkUpdate"
        activeMenu="inventory"
      >
        <Box sx={{ minHeight: "calc(100vh - 92px)", py: 2 }}>
          <>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              gap={{ xs: 2, md: 0 }}
              mb={2}
            >
              <Box>
                <Typography
                  variant="h4"
                  color={blackShade19}
                  fontSize={{ xs: "15px", md: "17px" }}
                  fontWeight="600"
                  m={{ xs: "10px 0 0px", md: "0 0 3px" }}
                >
                  Bulk{" "}
                  {commerceInfo?.info?.catalogPartnerInfo?.[0]?.status ==
                  "active"
                    ? "Pricing"
                    : "Inventory/Pricing"}{" "}
                  Update
                </Typography>

                {commerceInfo?.info?.catalogPartnerInfo?.[0]?.status ==
                  "active" && (
                  <>
                    <Typography
                      fontSize={{ xs: 12, md: 13.5 }}
                      fontWeight={{ xs: 500, md: 600 }}
                      color={blackColor}
                      lineHeight={{ xs: "17px", md: "24px" }}
                      mt={0.6}
                    >
                      Catalog Partner -{" "}
                      <span
                        style={{ color: matches ? blueColor04 : mobilePrimary }}
                      >
                        {toTitleCase(
                          commerceInfo?.info?.catalogPartnerInfo?.[0]
                            ?.catalogPartner || ""
                        ) || "-"}
                      </span>
                      , Facility Name -{" "}
                      <span
                        style={{ color: matches ? blueColor04 : mobilePrimary }}
                      >
                        {toTitleCase(
                          commerceInfo?.info?.catalogPartnerInfo?.[0]?.warehouse
                            ?.facilityName || ""
                        ) || "-"}
                      </span>
                    </Typography>
                  </>
                )}

                {matches && (
                  <Typography
                    variant="h6"
                    color={blackShade21}
                    fontSize="13px"
                    fontWeight={{ xs: 500, md: 500 }}
                    lineHeight={{ xs: "20px", md: "27px" }}
                  >
                    You may download the existing{" "}
                    {commerceInfo?.info?.catalogPartnerInfo?.[0]?.status ==
                    "active"
                      ? "pricing"
                      : "inventory/pricing"}{" "}
                    info onto an excel. Update details offline and upload
                    seamlessly.{" "}
                    {commerceInfo?.info?.catalogPartnerInfo?.[0]?.status ==
                    "active"
                      ? "Inventory management is handled by the Catalog Partner."
                      : null}
                  </Typography>
                )}
              </Box>
            </Box>

            {commerceInfo?.status === "new" && (
              <Box
                sx={{
                  bgcolor: lightRedColor02,
                  p: "8px 15px",
                  borderRadius: "10px",
                  mb: 2,
                }}
              >
                <Typography
                  fontSize={{ xs: 12, md: 13 }}
                  fontWeight={500}
                  color={outOfStockColor}
                  lineHeight="21px"
                >
                  E-Commerce Controls are not configured yet for this business.
                  Update E-Commerce details and try Bulk inventory update for
                  products again.{" "}
                  <Link
                    to={`/addCommerceInfo`}
                    style={{
                      color: greyColor49,
                      textDecoration: "underline",
                    }}
                  >
                    Click Here
                  </Link>
                </Typography>
              </Box>
            )}

            {matches && activeBusinessInfo && commerceInfo && (
              <InventoryBulkUpdateContent
                activeBusinessInfo={activeBusinessInfo}
                commerceInfo={commerceInfo}
                mainProducts={mainProducts}
                isDisabled={commerceInfo?.status === "new"}
                getAllMainProducts={getAllMainProductsWithVariants}
              />
            )}

            {!matches && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  backgroundColor: whiteColor,
                  border: logoImgborder1,
                  borderRadius: "10px",
                  p: "12px",
                  textAlign: "center",
                }}
              >
                <Box
                  sx={{
                    width: "45px",
                    height: "45px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "25px",
                    backgroundColor: "#E83251",
                    mb: 2,
                  }}
                >
                  <FileUploadOutlinedIcon
                    sx={{ fontSize: "24px", color: whiteColor }}
                  />
                </Box>

                <Typography sx={styles.infoText}>
                  Bulk{" "}
                  {commerceInfo?.info?.catalogPartnerInfo?.[0]?.status ==
                  "active"
                    ? "Pricing"
                    : "Inventory/Pricing"}{" "}
                  Upload feature is currently available only on our browser web
                  version.
                </Typography>

                <Typography sx={styles.infoText} my={1.5}>
                  For the best experience and to use this feature, please switch
                  to a desktop or laptop computer and access our site through a
                  standard web browser.
                </Typography>

                <Typography sx={styles.infoText}>
                  We appreciate your understanding
                </Typography>

                <Typography
                  sx={{
                    ...styles.infoText,
                    color: "#E83251",
                    textDecoration: "underline",
                  }}
                >
                  https://business.costbo.com/
                </Typography>
              </Box>
            )}
          </>
          {/* )} */}
        </Box>
      </DashboardLayout>
    </Box>
  );
}

export default InventoryBulkUpdate;

const styles = {
  infoText: {
    fontSize: 13,
    fontWeight: "500",
    color: blackShade19,
  },

  card: {
    bgcolor: whiteColor,
    border: border25,
    p: "20px 20px 15px 20px",
    borderRadius: "14px",
    mt: 3,
  },
};
